(function (){
  try {
    if (console && console.log) {
      art = '' +
        '   _____  /\\ __  ____   _____ _______ ___/\\  __ __  _____  _____    _/|    ___/\\  ____     \n' +
        '  /  ___\\/  |  \\/  _ \\_/  ___V__   __V  _  \\/  \\  \\/  ___\\/   __\\  /  !___/  _  \\/  _ \\_\n' +
        ' /____   \\  !   \\  _   \\____  \\/   \\/       \\ \\    \\      \\   ___\\/       \\      \\  _   \\\n' +
        '/         \\_____/______/______/\\___/\\___!___/__\\_  /______/____  /\\_______/__|___/       \\ \n' +
        '\\_________/ substancelab.com - Grow online       \\/            \\/              \\_________/ ';
      console.log(art)
    };
  } catch(error) {
  }
}());
